import axios from 'axios';
import { CONCEPTOS_EXTERNOS } from './types';

import { setAlert } from './alert';
import { changeLoader } from './loader';

export const listarConceptos = (filtros = {}) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const body = JSON.stringify({
        id_proyecto: filtros.id_proyecto ?? null,
        tipo: filtros.tipo ?? null
    });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/proyectos/listar_conceptos`, body, config);

        await dispatch({
            type: CONCEPTOS_EXTERNOS.LISTAR,
            payload: res.data?.conceptos || []
        });

        await dispatch(changeLoader(false));
        return true;
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: CONCEPTOS_EXTERNOS.ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al listar conceptos', 'danger'));
        return false;
    }
};

export const filtrarConceptos = (texto = '') => dispatch => {
    dispatch({
        type: CONCEPTOS_EXTERNOS.FILTRAR,
        payload: texto
    });
};

export const limpiarConceptos = () => dispatch => {
    dispatch({ type: CONCEPTOS_EXTERNOS.LIMPIAR });
};

export const crearConcepto = (data = {}) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const body = JSON.stringify({
        id_proyecto: data.id_proyecto || '',
        tipo: data.tipo ?? '',
        detalle: data.detalle || '',
        cantidad: data.cantidad ?? '',
        unidad: data.unidad || '',
        precio_unitario: data.precio_unitario ?? '',
        iva: data.iva === true || data.iva === 'true'
    });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/proyectos/crear_concepto`, body, config);

        await dispatch(changeLoader(false));

        if (!res.data?.success) {
            dispatch(setAlert(res.data?.msg || 'No se pudo crear el concepto', 'danger'));
            return false;
        }

        dispatch(setAlert(res.data?.msg || 'Concepto creado correctamente', 'success'));

        await dispatch(listarConceptos({ id_proyecto: data.id_proyecto }));

        return true;
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: CONCEPTOS_EXTERNOS.ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al crear concepto', 'danger'));
        return false;
    }
};

export const editarConcepto = (data = {}) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const body = JSON.stringify({
        id: data.id || '',
        tipo: data.tipo ?? '',
        detalle: data.detalle || '',
        cantidad: data.cantidad ?? '',
        unidad: data.unidad || '',
        precio_unitario: data.precio_unitario ?? '',
        iva: data.iva === true || data.iva === 'true'
    });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/proyectos/editar_concepto`, body, config);

        await dispatch(changeLoader(false));

        if (!res.data?.success) {
            dispatch(setAlert(res.data?.msg || 'No se pudo editar el concepto', 'danger'));
            return false;
        }

        dispatch(setAlert(res.data?.msg || 'Concepto editado correctamente', 'success'));

        await dispatch(listarConceptos({ id_proyecto: data.id_proyecto }));

        return true;
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: CONCEPTOS_EXTERNOS.ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al editar concepto', 'danger'));
        return false;
    }
};

export const eliminarConcepto = (id, id_proyecto) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const body = JSON.stringify({ id });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/proyectos/eliminar_concepto`, body, config);

        await dispatch(changeLoader(false));

        if (!res.data?.success) {
            dispatch(setAlert(res.data?.msg || 'No se pudo eliminar el concepto', 'danger'));
            return false;
        }

        dispatch(setAlert(res.data?.msg || 'Concepto eliminado correctamente', 'success'));

        await dispatch(listarConceptos({ id_proyecto }));

        return true;
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: CONCEPTOS_EXTERNOS.ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al eliminar concepto', 'danger'));
        return false;
    }
};
